import { DEV_BO_API, DEV_MP_API } from 'src/config-global';

export const endpoints = {
  getCurrentUser: `${DEV_BO_API}api/users/me`,
  getBuyerSiteDetails: `${DEV_BO_API}api/buyers/:buyerOrgId/sites/:buyerSiteId`,
  getBuyerSites: `${DEV_MP_API}api/buyers/:buyerOrgId/sites`,
  getBuyerSiteLinkedSites: `${DEV_MP_API}api/buyers/:buyerOrgId/sites/:buyerSiteId/linked-sites`,
  getAllAttributes: `${DEV_BO_API}api/attributes?attributeTypes=1,2,3,4,5,6,7,8,9,10,11,12,13`,
  getAttributes: `${DEV_BO_API}api/attributes`,
  getAllRoles: `${DEV_BO_API}api/roles`,
  searchProducts: `${DEV_MP_API}api/products/buyerSearch`,
  getListOfFavouritesCollections: `${DEV_MP_API}api/users/favorites`,
  addFavouritesCollection: `${DEV_MP_API}api/users/favorites`,
  deleteFavouritesCollection: `${DEV_MP_API}api/users/favorites/:collectionId`,
  updateFavouritesCollection: `${DEV_MP_API}api/users/favorites/:collectionId`,
  deleteFavouritesItem: `${DEV_MP_API}api/users/favorites/:collectionId/item/:itemId`,
  addProductToCart: `${DEV_MP_API}api/users/cart/item`,
  validateCart: `${DEV_MP_API}api/users/cart/checkout/validate`,
  addMultipleProductsToCart: `${DEV_MP_API}api/users/cart/items`,
  checkoutCart: `${DEV_MP_API}api/users/cart/checkout`,
  removeFromCart: `${DEV_MP_API}api/users/cart/item/:itemId`,
  updateQuantity: `${DEV_MP_API}api/users/cart/item/:itemId`,
  editOrder: `${DEV_MP_API}api/users/orders/:orderId`,
  getUserCart: `${DEV_MP_API}api/users/cart`,
  updateBasketDetails: `${DEV_MP_API}api/users/cart`,
  cancelOrder: `${DEV_MP_API}api/users/orders/:orderId`,
  addProductToFavouritesCollection: `${DEV_MP_API}api/users/favorites/:collectionId/item`,
  controlFavouritesAccess: `${DEV_MP_API}api/users/favorites/:collectionId/share`,
  getOrders: `${DEV_MP_API}api/users/orders`,
  getOrderDetails: `${DEV_MP_API}api/users/orders/:id`,
  downloadOrderPdf: `${DEV_MP_API}api/users/orders/:orderId/pdf`,
  createOrderIssue: `${DEV_MP_API}api/users/orders/:id/issues`,
  uploadOrderIssueImage: `${DEV_MP_API}api/users/orders/:orderId/issues/images`,
  updateOrderIssue: `${DEV_MP_API}api/users/orders/:id/issues/:issueId`,
  createOrderIssueReply: `${DEV_MP_API}api/users/orders/:id/issues/:issueId/replies`,
  getOrderIssuesForOrder: `${DEV_MP_API}api/users/orders/:id/issues`,
  getOrderIssueById: `${DEV_MP_API}api/users/orders/:id/issues/:issueId`,
  getOrderIssuesLog: `${DEV_MP_API}api/users/orders/issuesLog`,
  addWeightToProduct: `${DEV_MP_API}api/users/orders/:orderId/products/:orderProductId/weightDelivered`,
  createOrderIssueReplyByEmail: `${DEV_MP_API}api/order-issue-reply/:emailReplyId/reply`,
  getOrderIssueByEmailId: `${DEV_MP_API}api/order-issue-reply/:emailReplyId`,
  getProductDetails: `${DEV_MP_API}api/products/:stockId`,
  getProducers: `${DEV_BO_API}api/producers/buyer/:buyerOrgId/site/:buyerSiteId`,
  getProducerDetails: `${DEV_BO_API}api/producers/:producerId`,
  registerUser: `${DEV_BO_API}api/users/register`,
  mfaEnable: `${DEV_BO_API}api/mfa/enable`,
  mfaVerify: `${DEV_BO_API}api/mfa/verify`,
  forgotPassword: `${DEV_BO_API}api/users/forgotPassword`,
  resetPassword: `${DEV_BO_API}api/users/resetPassword`,
  changePassword: `${DEV_BO_API}api/users/changePassword`,
  getAllDistributors: `${DEV_BO_API}api/distributors`,
  getDistributorSites: `${DEV_BO_API}api/distributors/:distributorId/sites`,
  exportPurchaseOrders: `${DEV_MP_API}api/users/orders/export/po`,
  exportGoodsReceivedNotes: `${DEV_MP_API}api/users/orders/export/grn`,
  exportCreditNoteRequests: `${DEV_MP_API}api/users/orders/export/cnr`,
  getAllNewsPosts: `${DEV_MP_API}api/news`,
  newsPostById: `${DEV_MP_API}api/news/:id`,
  getGenerationHistory: `${DEV_BO_API}api/prompt/generation-history`,
  getProducersByBuyerSite: `${DEV_BO_API}api/producers/buyer/:buyerOrgId/site/:buyerSiteId`,
  getProductTemplatesByProducer: `${DEV_BO_API}api/prompt/producer/:producerId/products`,
  generateStory: `${DEV_BO_API}api/prompt`,
  getProductImages: `${DEV_BO_API}api/prompt/product/:productId/images`,
  searchSeasonalCalendar: `${DEV_MP_API}api/buyers/:buyerOrgId/sites/:buyerSiteId/season-calendar/search`,
  getFinanceOrders: `${DEV_MP_API}api/users/finance`,
  getFinanceFilterOptions: `${DEV_MP_API}api/users/finance/filter-options`,
  getFinanceInvoiceById: `${DEV_MP_API}api/users/finance/invoices/:invoiceId`,
  getRecommendations: `${DEV_MP_API}api/buyers/:buyerOrgId/sites/:buyerSiteId/products/:productTemplateId/recommendations`,
};
export type Endpoint = (typeof endpoints)[keyof typeof endpoints];
